import React from "react";
import Table from "../components/Table/Table";

export function Skillset(props) {
  console.log('skillset>>',props?.details);
  return(
    <>
    <div className="skillset_outer h-full relative pb-[80px]">
      <div className="table-data pras">
        <Table data={props?.details}  from={props?.from}/>{" "}
      </div>
      { props?.from != 'lattice' ? 
      <div className="table-data hp">
        <Table data={props?.details}  from={props?.from} />{" "}
      </div>
      :<></>
      }

      <div className="legend bg-[#f8fbff] border-[0.5px] border-[#c2daff] flex relative bottom-0 w-full" >
        <h5 className="rotate-[270deg] translate-y-2/4 absolute bg-white font-bold p-1 uppercase top-[50%] mt-[-27px] left-[-8px]">Legend</h5>
        <ul className="list-none columns-4 pl-10 gap-2 my-2">
          <li className="list-none text-black text-[11px] ml-0 leading-4"><b className="text-[#033d9b] font-semibold block">Beginner</b> Limited knowledge</li>
          <li className="list-none text-black text-[11px] ml-0 leading-4"><b className="text-[#033d9b] font-semibold block">Intermediate</b> Familiar &amp; can perform with help</li>
          <li className="list-none text-black text-[11px] ml-0 leading-4"><b className="text-[#033d9b] font-semibold block">Proficient</b> Can perform independently </li>
          <li className="list-none text-black text-[11px] ml-0 leading-4"><b className="text-[#033d9b] font-semibold block">Expert</b> Can train others</li>
        </ul>
      </div>
      </div>
    </>
  )
  
}
